/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GET_CBO,
  GET_CBO_SUB_GRAND_CHILD,
  GET_CBO_SUB_OCCUPATION,
  GET_CBO_SUB_SON_OCCUPATION,
} from '@portal/actions/actionTypes';

export const initialState: reducers.CBOReducer = {
  cboSubGreatGrandsonOccupation: null,
  cboSubGreatGreatGrandsonOccupation: null,
  cboSubOccupation: null,
  cbo: null,
};

const cboOccupationReducer = (
  state = initialState,
  action: any
): reducers.CBOReducer => {
  const { payload } = action;
  switch (action.type) {
    case GET_CBO:
      return {
        ...state,
        cbo: payload,
      };

    case GET_CBO_SUB_OCCUPATION:
      return {
        ...state,
        cboSubOccupation: payload,
      };

    case GET_CBO_SUB_SON_OCCUPATION:
      return {
        ...state,
        cboSubGreatGrandsonOccupation: payload,
      };

    case GET_CBO_SUB_GRAND_CHILD:
      return {
        ...state,
        cboSubGreatGreatGrandsonOccupation: payload,
      };

    default:
      return state;
  }
};

export default cboOccupationReducer;
